import React from "react";
import Sidebar from "./Sidebar";
import DeshBoardFooter from "./DeshBoardFooter";
import { AllDeshbordCountData } from "../FetchAPI";
import { Link } from "react-router-dom";
import { useAuth } from "../../Store/AuthContext";
import DeshboardAllPlans from "./DeshBoardPlans/DeshboardAllPlans";
import AllSearchBox from "./AllSearchBox";
import { Helmet } from "react-helmet";

export default function Deshbard() {
  const { RendomTokenfetch } = useAuth();

  // const [UserLead, Status, msg] = AllserviceLeads(RendomTokenfetch, "5", "1");
  const [DeshbordCount] = AllDeshbordCountData(RendomTokenfetch);

  return (
    <>
      <Helmet>
        <meta name="robots" content="index, follow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <div className="sidebar-backdrop"></div>
        <Sidebar />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="row">
              {DeshbordCount &&
                DeshbordCount.map((value, index) => (
                  <div
                    key={index}
                    className="col-xl-3 col-lg-6 col-md-6 col-sm-12"
                  >
                    <Link to={`/${value.redirect_link}`}>
                      <div className="ui-item">
                        <div className="left">
                          <i
                            className={`icon ${value.icon}`}
                            style={{ color: value.color }}
                            aria-hidden="true"
                          ></i>
                        </div>
                        <div className="right">
                          <h4 style={{ color: value.color }}>
                            {value.counter}
                          </h4>
                          <p>{value.name}</p>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
            </div>
            <div
              className="job-search-form wow fadeInUp"
              data-wow-delay="1500ms"
              style={{ width: "50%" }}
            >
              <AllSearchBox />
            </div>
          </div>
        </section>

        <DeshboardAllPlans />

        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
